// Customizable Area Start
import { loadStripe } from "@stripe/stripe-js";
import { BlockComponent } from "../../../framework/src/BlockComponent";
import React, { MouseEvent } from "react";
import { PlanPricing, ProductData } from "./EmailAccountRegistrationController.web";
import { removeStorageData, setStorageData } from "../../../framework/src/Utilities";
import { setSubscriptionRequired } from "../../../components/src/AuthService";
import { Message } from "../../../framework/src/Message";
import MessageEnum, {
  getName,
} from "../../../framework/src/Messages/MessageEnum";
import { runEngine } from "../../../framework/src/RunEngine";

export const configJSON = require("./config");

export const stripePromise = loadStripe(configJSON.stripeKey);

export interface Props {
  handleGoBackClick: () => void;
  paymentPrize: number;
  platformManagementPaymentPlans: ProductData[];
  attributeName: string;
  stripePaymentData: any;
  clientSecretKey:string;
  selectedPlanData:any;
  userToken:string;
  platformManagementChecked: boolean;
  selectedPricing: PlanPricing;
}

interface S {
  stripePaymentData: any;
  attributeName: string;
  paymentPrize: number;
  flag: boolean
  clientSecretKey:string;
  selectedPlanData:any;
  userToken:string;
}
interface SS {
  id: any;
}
export default class EmailAccountRegistrationController extends BlockComponent<
  Props,
  S,
  SS
> {
  apiUserRegistrationId: any = "";
  constructor(props: Props) {
    super(props);
    this.receive = this.receive.bind(this);

    this.state = {
      attributeName: this.props.attributeName,
      paymentPrize: this.props.paymentPrize,
      stripePaymentData: this.props.stripePaymentData,
      clientSecretKey: this.props.clientSecretKey,
      flag: false,
      selectedPlanData:this.props.selectedPlanData,
      userToken:this.props.userToken
    };
  }

  // handleSubmit = async (
  //   event: MouseEvent<HTMLButtonElement>,
  //   stripe: any,
  //   elements: any
  // ) => {
  //   if (!stripe || !elements) {
  //     return;
  //   }
  //   console.log("stripestripestripestripestripe", stripe); 
  //   console.log("elementselementselementselements", elements); 

  //   const token = sessionStorage.getItem("userToken")!
  //   console.log("tokentokentokentoken", token); 
  //   this.props?.doSubcriptionSelection()
  //   await setStorageData("authToken", token)

  //   const result = await stripe.confirmPayment({
  //     elements,
  //     confirmParams: {
  //       return_url: `${
  //         new URL(window.location.href).origin + "/"
  //       }dashboard`,
  //     },
  //   });
  //   console.log("resultresultresult", result); 
    

  //   if (result.error) {
  //     await removeStorageData("authToken")
  //     console.log(result.error.message);
  //   }
  // };


 handleSubmit = async (
  event: MouseEvent<HTMLButtonElement>,
  stripe: any,
  elements: any
) => {
  event.preventDefault(); // Prevent default form behavior

  if (!stripe || !elements) {
    console.error("Stripe or Elements not loaded.");
    return;
  }

  const token = sessionStorage.getItem("userToken") || this.state.userToken;
  if (!token) {
    console.error("No token found in sessionStorage or state.");
    return;
  }

  // ✅ 1. Store token in localStorage BEFORE payment confirmation
  // Store it using both methods to ensure it's persisted
  await setStorageData("authToken", token);
  // Also set directly in localStorage as backup
  localStorage.setItem("authToken", token);

  // ✅ 2. Call doSubcriptionSelection (don't wait since subscription is already created)
  this.doSubcriptionSelection();

  // ✅ 3. Continue Stripe payment confirmation
  try {
    const result = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: `${new URL(window.location.href).origin}/dashboard`,
      },
      redirect: 'if_required', // Only redirect if 3D Secure is needed
    });

    if (result.error) {
      await removeStorageData("authToken");
      localStorage.removeItem("authToken");
      console.error("Stripe payment error:", result.error.message);
    } else {
      console.log("✅ Payment successful!", result);
      
      // Ensure token is set again before redirecting
      await setStorageData("authToken", token);
      localStorage.setItem("authToken", token);
      console.log("✅ Token confirmed in localStorage before redirect");
      setSubscriptionRequired(false);

      // Redirect to dashboard after successful payment
      console.log("Redirecting to dashboard...");
      // Use setTimeout to ensure token is saved before redirect
      setTimeout(() => {
        window.location.href = "/dashboard";
      }, 200);
    }
  } catch (error) {
    console.error("Error confirming payment:", error);
    await removeStorageData("authToken");
    localStorage.removeItem("authToken");
  }
};


async doSubcriptionSelection() {
  const selectedPlan = this.state.selectedPlanData;
  console.log("selectedPlanselectedPlan",selectedPlan);
  console.log("selectedPlanselectedPlan123",this.state.selectedPlanData);
  

  if (
    !selectedPlan ||
    !selectedPlan.stripe_price_id ||
    !selectedPlan.plan_id
  ) {
    console.warn("❌ No valid selected plan found.", selectedPlan);
    return false;
  }

  // Get subscription_id from stripePaymentData (if subscription was already created) 
  // or use productId as fallback
  const subscriptionId = this.state.stripePaymentData?.id 
    || this.state.stripePaymentData?.attributes?.id
    || this.state.stripePaymentData?.data?.id
    || selectedPlan.subscription_id 
    || selectedPlan.productId;

  if (!subscriptionId) {
    console.warn("❌ No subscription ID found. Using productId as fallback.");
  }

  const attrs = {
    stripe_price_id: selectedPlan.stripe_price_id,
    plan_id: selectedPlan.plan_id,
    platform_management: this.props.platformManagementChecked || false,
    subscription_id: subscriptionId || selectedPlan.productId,
  };

  const httpBody = {
    subscription: attrs,
  };

  const headerData = {
    "Content-Type": configJSON.signupEmailApiContentType,
    Token: this.state.userToken,
  };

  let requestMessage = new Message(
    getName(MessageEnum.RestAPIRequestMessage)
  );
  this.apiUserRegistrationId = requestMessage.messageId;

  requestMessage.addData(
    getName(MessageEnum.RestAPIRequestMethodMessage),
    configJSON.signupAPiMethod
  );
  requestMessage.addData(
    getName(MessageEnum.RestAPIRequestBodyMessage),
    JSON.stringify(httpBody)
  );
  requestMessage.addData(
    getName(MessageEnum.RestAPIResponceEndPointMessage),
    configJSON.StripesubScriptionsDetails
  );
  requestMessage.addData(
    getName(MessageEnum.RestAPIRequestHeaderMessage),
    JSON.stringify(headerData)
  );

  runEngine.sendMessage(requestMessage.id, requestMessage); // ✅ You had this commented out — it's required

  return true;
}



 async receive(from: string, message: Message) {
    const messageType = getName(MessageEnum.RestAPIResponceMessage);

    if (messageType === message.id) {
      const apiRequestCallId = message.getData(
        getName(MessageEnum.RestAPIResponceDataMessage)
      );
      const responseJson = message.getData(
        getName(MessageEnum.RestAPIResponceSuccessMessage)
      );

      if (
        apiRequestCallId != null &&
        apiRequestCallId === this.apiUserRegistrationId
      ) {
        // this.apicallresponseData(responseJson);
        console.log("createIntentIdcreateIntentId here is respons09876543", responseJson);

      }

    }
  }


  getPlatformManagementPrice = () => {    
    return Number(this.props.platformManagementPaymentPlans?.[0]?.attributes.plans.find(plan => plan.interval === "month")?.price || "0")
  }
}
// Customizable Area End
